import ModalController from '../../assets/js/controllers/modal';

export default class ModalTrigger {

	static selector = '[data-modal-trigger]';

	// class variables

	el = {};

	// constructor

	constructor(container) {
		this.el = {
			container
		};

		this.initialize();
	}

	// init

	initialize() {
		this.#addEventListeners();
	}

	// event listeners

	#addEventListeners = () => {
		this.el.container.addEventListener('click', this.#onClick);
	}

	#removeEventListeners = () => {
		this.el.container.removeEventListener('click', this.#onClick);
	}

	// listener methods

	#onClick = () => {
		const modalId = this.el.container.getAttribute('data-modal-trigger');
		ModalController.open(modalId);
	};

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
